import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ChangeStateComponent } from '../change-state/change-state.component';
import { MatDialog } from '@angular/material/dialog';
import { AddUserComponent } from '../add-user/add-user.component';
import { DatePipe } from '@angular/common';
import { Months } from 'src/app/enums/months.enum';
import { AdminService } from 'src/app/services/admin.service';
import { AsesorRegisterComponent } from '../asesor-register/asesor-register.component';
import { AlertComponent } from '../alert/alert.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile-user',
  templateUrl: './profile-user.component.html',
  styleUrls: ['./profile-user.component.scss']
})
export class ProfileUserComponent implements OnInit {
  @Input() rol : number = 0;
  @Input() user: any;
  @Output() getUser = new EventEmitter<boolean>(false);
  statesColorsList: any[]=[];

  constructor(
    private dialog: MatDialog,
    private adminservice: AdminService,
    private router: Router
  ) { }

  ngOnInit() {
    this.statesColors();
  }

  changeState(){
    let dialogRef = this.dialog.open(ChangeStateComponent,{
      width: '776px',
      disableClose: true,
      data: this.user
    });

    dialogRef.afterClosed().subscribe(
      (response)=>{
        if (response) {
          this.user.cliente_estado = response;
        }
      }
    );
  }

  editUser(){
    if (this.rol == 3) {

      const dataUser = {
        clientId: this.user.id ,
        fullname:  this.user.nombre_completo,
        country: this.user.pais_id,
        city: this.user.ciudad,
        address: this.user.direccion,
        phone: this.user.numero_telefono,
        email: this.user.correo,
        fecnac: this.user.fecha_nacimiento ? `${this.user.fecha_nacimiento.split('-')[2]}/${this.user.fecha_nacimiento.split('-')[1]}/${this.user.fecha_nacimiento.split('-')[0]}` :
        '',
        numHijos: this.user.numero_hijos,
        enterprise: this.user.empresa_trabajo,
        salary: this.user.cliente_ingreso_id,
        heritage: this.user.cliente_patrimonio_id,
        income: this.user.tipo_ingreo,
      }
   
      let dialogRef = this.dialog.open(AddUserComponent,{
        width: '776px',
        disableClose: true,
        autoFocus: false,
        data: dataUser
      });

      dialogRef.afterClosed().subscribe(
        (response)=>{
          if (response) {
            this.getUser.emit(true)
          }
        }
      )

    }else{

      const dataAsesor = {
        userId: this.user.id ,
        fullname:  this.user.nombres,
        country: this.user.pais_id,
        city: this.user.ciudad,
        address: this.user.direccion,
        phone: this.user.numero_telefono,
        email: this.user.correo,
        fecnac: this.user.fecha_nacimiento ? `${this.user.fecha_nacimiento.split('-')[2]}/${this.user.fecha_nacimiento.split('-')[1]}/${this.user.fecha_nacimiento.split('-')[0]}` : '',
        range: this.user.rango_id,
        typeDoc: this.user.tipo_documento_id,
        numberDocument: this.user.numero_documento,
        plans: this.user.plan_id,
        permits: this.user.permiso_especial === 'No' ? false : true
      }
      let dialogRef  = this.dialog.open(AsesorRegisterComponent,{
        width: '776px',
        disableClose: true,
        autoFocus: false,
        data: dataAsesor
      });

      dialogRef.afterClosed().subscribe(
        (response)=>{
          if (response) {
            this.getUser.emit(true)
          }
        }
      )

    }
  }

  deleteUser() {
    let dialogRef = this.dialog.open(AlertComponent, {
      width: '776px',
      disableClose: true,
      data: {
        type: 'alert',
        title: this.rol == 1 ? '¿Deseas eliminar este asesor?' : '¿Deseas eliminar este cliente?',
        description: 'Recuerda que si decides hacerlo, todos los datos asociados se eliminarán.',
        textButton: 'Eliminar'
      }
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        const request = this.rol == 1
          ? { usuario_id: this.user.id }
          : { cliente_id: this.user.id };

        const action = this.rol == 1
          ? this.adminservice.deleteUser(request)
          : this.adminservice.deleteClient(request);

        action.subscribe((response: any) => {
          this.dialog.open(AlertComponent, {
            width: '776px',
            disableClose: true,
            data: {
              type: response.rtn ? 'success' : 'alert',
              title: response.rtn ? 'Eliminado correctamente' : 'Error al eliminar',
              description: response.rtn ? `Se ha eliminado correctamente el ${this.rol === 1 ? 'asesor':'cliente'}` : response.message,
              textButton: 'Aceptar'
            }
          });
          if (response.rtn) {
            this.router.navigate([this.rol == 1 ? '/asesores' : '/clientes']);
          }
        });
      }
    });
  }

  getDateFormated(date:string){
    let day = (new Date(date)).getDate();
    //@ts-ignore
    let month = Months.find((element)=> element.value == (new Date(date)).getMonth()).nameLarge;
    let year = (new Date(date)).getFullYear();
    
    return `${day} de ${month} del ${year}`
  }

  statesColors(){
    this.adminservice.getStates().subscribe(
      (response)=>{
        this.statesColorsList = response;
      }
    );
  }

  getColor(state:string):string{
    return this.statesColorsList.find((element)=> element.label == state).class;
  }

}
